import { Orientation3D, Position3D } from '@fixtuur/fine';
import * as H from './handedness';
export const emptyPose = (possibleHandedness) => {
    return {
        position: new Position3D(0, 0, 0),
        orientation: Orientation3D.identity(),
        possibleHandedness: possibleHandedness ?? H.intersectionMonoid.empty,
    };
};
export const fromRawPose = (rawPose) => ({
    possibleHandedness: H.everyPossibleHandedness(),
    orientation: Orientation3D.fromQuaternion([
        rawPose.orientation.w,
        rawPose.orientation.x,
        rawPose.orientation.y,
        rawPose.orientation.z,
    ]),
    position: new Position3D(rawPose.position.x, rawPose.position.y, rawPose.position.z),
});
export const poseString = (pose) => {
    const position = pose.position.toString();
    const orientation = pose.orientation
        .euler()
        .map(v => v.toFixed(2))
        .toString();
    const possibleHandedness = H.possibleHandednessString(pose.possibleHandedness);
    return `Pose( position: ${position}, orientation: ${orientation}, possibleHandedness: ${possibleHandedness} )`;
};
